// frontend/src/state/useColumnsState.ts

import { useCallback, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

export function useColumnsState(groupBy: string[]): [string, (next: string) => void] {
  const [searchParams, setSearchParams] = useSearchParams()
  const raw = searchParams.get('columns') ?? ''
  const valid = raw && groupBy.includes(raw) ? raw : ''

  const setColumns = useCallback(
    (next: string) => {
      const ok = next && groupBy.includes(next)
      setSearchParams(
        (prev) => {
          const params = new URLSearchParams(prev)
          if (ok) {
            params.set('columns', next)
          } else {
            params.delete('columns')
          }
          return params
        },
        { replace: false },
      )
    },
    [setSearchParams, groupBy],
  )

  // Reconciliation: if the URL claims a dim that's no longer in groupBy, drop it.
  useEffect(() => {
    if (raw && !groupBy.includes(raw)) {
      setSearchParams(
        (prev) => {
          const params = new URLSearchParams(prev)
          params.delete('columns')
          return params
        },
        { replace: true },
      )
    }
  }, [raw, groupBy, setSearchParams])

  return [valid, setColumns]
}
